// Libraries
import React, { useContext, useEffect, Fragment } from 'react';

// Components
import ScreenInfo from '../../components/ScreenInfo';
import OverallRating from './components/OverallRating';
import CategoryRating from './components/CategoryRating';
import ProductRecommendation from './components/ProductRecommendation';

// Services and contexts
import QuestionsContext from '../../contexts/QuestionsContext';
import RatingsContext from '../../contexts/RatingsContext';

export default function Results() {
  const { questions } = useContext(QuestionsContext);
  const { calculateRatings } = useContext(RatingsContext);
  const userRatings = calculateRatings(questions);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <ScreenInfo title="SCREEN_RESULTS_TITLE" description="SCREEN_RESULTS_INSTRUCTIONS" />
      <OverallRating userRating={userRatings.overall} />
      {userRatings.overall > 0 ? (
        <Fragment>
          <CategoryRating userRatings={userRatings.byCategory} />
          <ProductRecommendation userRatings={userRatings.byCategory} />
        </Fragment>
      ) : null}
    </Fragment>
  );
}
